import { TagsCell } from "common/components/tagsCell/tagsCell";
import { displayDollar, formatBool } from "utilities/tableUtility";
import { convertIntoDashUSFormat } from "utilities/dateUtility";
import { DefaultColumnOptions } from "hooks/useDataGrid/options";
import { tooltipTagRenderer } from "../billingCommissions/submitToBilling/tableColumns";

export const Columns = [
  DefaultColumnOptions.Id,
  {
    headerName: "Job Recruiter(s)",
    field: "searchRecruiters",
    sortable: false,
    cellRenderer: (params) => (
      <TagsCell items={params.data.jobRecruiters} color="#0070C0" />
    ),
    tooltipValueGetter: ({ data }) =>
      data.jobRecruiters.map((item) => item.name).join(", "),
    tooltipComponent: (params) => tooltipTagRenderer(params, "jobRecruiters"),
  },
  {
    headerName: "Title",
    field: "title",
    tooltipField: "title",
  },
  {
    headerName: "Current Openings",
    field: "currentOpenings",
    tooltipField: "currentOpenings",
  },
  {
    headerName: "Job Location",
    field: "jobLocation.name",
    tooltipField: "jobLocation.name",
  },
  {
    headerName: "Job Department",
    field: "jobDepartment.name",
    tooltipField: "jobDepartment.name",
  },
  {
    headerName: "Job Group",
    field: "jobGroup.name",
    tooltipField: "jobGroup.name",
  },
  {
    headerName: "Job Hiring Manager(s)",
    field: "searchHiringManagers",
    sortable: false,
    tooltipValueGetter: ({ data }) =>
      data.jobHiringManagers.map((item) => item.name).join(", "),
    tooltipComponent: (params) =>
      tooltipTagRenderer(params, "jobHiringManagers"),
    cellRenderer: (params) => (
      <TagsCell items={params.data.jobHiringManagers} color="#BDD7EE" />
    ),
  },
  {
    headerName: "Recruiting Start Date",
    field: "recruitingStartDate",
    headerTooltip: "Recruiting Start Date",
    sort: "asc",
    valueGetter: ({ data }) =>
      convertIntoDashUSFormat(data.recruitingStartDate, false),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Min Pay",
    field: "minPay",
    tooltipField: "minPay",
    valueGetter: ({ data }) => displayDollar(data.minPay),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Max Pay",
    field: "maxPay",
    valueGetter: ({ data }) => displayDollar(data.maxPay),
    tooltipValueGetter: ({ value }) => value,
  },
  {
    headerName: "Billing Tier",
    field: "jobTier.name",
    tooltipField: "jobTier.name",
  },
  {
    headerName: "ATS ID",
    field: "extAtsId",
    tooltipField: "extAtsId",
  },
  {
    headerName: "Job Status",
    field: "jobStatus.name",
    tooltipField: "jobStatus.name",
  },
  {
    headerName: "Cancelled?",
    field: "isCancel",
    valueGetter: ({ data }) => formatBool(data.isCancel),
    tooltipValueGetter: ({ value }) => value,
  },
];
